import { vndHlp, quickViewInit, initSwatch } from "//mvhstudios.co.uk/cdn/shop/t/36/assets/theme.js?v=94211074440373630911791383122";

var collectionPage = {
  // Collection Layout
  $container: document.querySelector('.collection-layout'),
  $vnd_main_ctn: document.getElementById("collectionsContent"),
  // Collection sort container
  $sort_ctn: document.querySelector('.collection-sort'),
  $loading_bg: document.querySelector(".result-loading"),
  $load_more_point: document.getElementById('infinite-more-link'),
  $load_more_btn: document.querySelector('.load-more'),
  $sidebar: document.querySelector('.collection-layout .mobile-sidebar'),
  waypoint: null,

  init() {
    const _this = this;

    if ( vndTheme.scr_tm ) {
      _this.scrollToMain(700);
    }

    _this.showByGroup();
    _this.initGridSwitch();
    _this.initInfinitScroll();
    _this.$sort_ctn && new vndTheme.Dropdowns(_this.$sort_ctn);
  },

  scrollToMain(sec) {
    let element = '.collection-sort';
    if ( vndTpl == 'search' ) {
      element = '#shopify-section-template-search';
    }

    if ( $(element).length ) {
      $('body,html').animate({
        scrollTop: $(element).offset().top - 65
      }, sec || 350);
    }
  },

  showByGroup() {
    const $sort_by = document.getElementById('group-by');

    if (!this.$sort_ctn || !$sort_by) {
      return
    }

    if (this.$sort_ctn.classList.contains('cfd-classic')) {
      $sort_by.addEventListener('change', function() {
        fetch(vndTheme.routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              _collectionPagination: this.value
            }
          })
        })
        .then(function(response) { response.text() })
        .then(function(responseText) {
          collectionPage.replaceContent(window.location.href, window.location.href);
        });
      });
    } else {
      const $sorts = this.$sort_ctn.querySelectorAll('.group-wrapper .dd-pp__item');
      const $sort_close = this.$sort_ctn.querySelector('.group-wrapper .dd-pp__close');

      for ( let i = 0; i < $sorts.length; i++ ) {
        const node = $sorts[i];

        node.onclick = function() {
          $sort_by.firstChild.innerText = this.innerText;
          $sort_close.click();
          if ( !this.classList.contains('active') ) {
            fetch(vndTheme.routes.cart_update_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                attributes: {
                  _collectionPagination: this.dataset.value
                }
              })
            })
            .then(function(response) { response.text() })
            .then(function(responseText) {
              collectionPage.replaceContent(window.location.href, window.location.href);
            });
          }
        }
      }
    }
  },

  initGridSwitch() {
    $('.collection-grid__switcher').on('click', function(e) {
      e.preventDefault();

      $('.collection-grid__switcher').removeClass('active');
      $(this).addClass('active');

      $('#collectionsContent .result-loading').addClass('active');

      if ( $(this).hasClass('grid') ) {
        $('#collectionsContent').removeClass('list').addClass('grid');
      } else {
        $('#collectionsContent').removeClass('grid').addClass('list');
      }

      setTimeout( function() {
        $('#collectionsContent .result-loading').removeClass('active');
      }, 250);
    });
  },

  initInfinitScroll() {
    const _this = this;
    if ( _this.$load_more_point ) {
      _this.waypoint = new Waypoint({
        element: _this.$load_more_point,
        offset: '85%',
        handler: function(direction) {
          let $targetElement = $(this.element);
          const targetUrl = $targetElement.data('target');
          if ( !targetUrl || $targetElement.hasClass('disabled') ) { return; }
          _this.replaceContent(targetUrl, targetUrl, 'append');
        }
      });
    }

    if ( vndTheme.stt.eb_ajx_flt ) {
      const paginates = _this.$container.querySelectorAll('.paginate-item a');
      for ( let i = 0; i < paginates.length; i++ ) {
        const pagenator = paginates[i];
        pagenator.onclick = function( e ) {
          e.preventDefault();
          let url = e.currentTarget.href;
          _this.replaceContent(url, url);
        }
      }
    }

    if ( _this.$load_more_btn ) {
      $(_this.$load_more_btn).on('click', function(e) {
        e.preventDefault();
        var $targetElement = $(this);
        var targetUrl = $targetElement.data('target');
        if ( !targetUrl ) {
          return;
        }

        _this.replaceContent(targetUrl, targetUrl, 'append');
      });
    };
  },

  replaceContent(targetUrl, w_url, method='replace') {
    const _this = this;

    let $pointer = null;
    if (_this.$load_more_btn) {
      $pointer = document.querySelector('.load-more');
    } else if (_this.$load_more_point) {
      $pointer = document.getElementById('infinite-more-link');
    }

    _this.$vnd_main_ctn.classList.add('loading');
    _this.$loading_bg.classList.add('active');
    $pointer && $pointer.classList.add('disabled');

    fetch(targetUrl)
    .then(response => response.text())
    .then(result => {
      const $result = new DOMParser().parseFromString(result, 'text/html');

      var collectionSort = $result.querySelector('.collection-sort');
      if (_this.$sort_ctn) {
        _this.$sort_ctn.innerHTML = collectionSort.innerHTML;
      }

      if (_this.$sidebar) {
        const $sidebar = $result.querySelector('.mobile-sidebar');
        _this.$sidebar.innerHTML = $sidebar.innerHTML;
      }

      let filteredResult = $result.querySelector('#collectionsContent .row');
      if (method == 'replace') {
        document.querySelector('#collectionsContent .row').remove();
        document.getElementById('collectionsContent').append(filteredResult);
      } else {
        $pointer && $pointer.remove();
        while (filteredResult.children.length > 0) {
          document.querySelector('#collectionsContent .row').appendChild(filteredResult.children[0]);
        }
      }

      _this.$load_more_point = _this.$vnd_main_ctn.querySelector('#infinite-more-link');
      _this.$load_more_btn = _this.$vnd_main_ctn.querySelector('.load-more');

      if (method == 'replace' ) {
        _this.scrollToMain(360);
        if (w_url) {
          window.history.pushState('','', w_url);
        }
      } else {
        _this.waypoint && _this.waypoint.destroy();
      }

      setTimeout(function() {
        _this.$vnd_main_ctn.classList.remove('loading');
        _this.$loading_bg.classList.remove('active');
      }, 750);

      _this.initInfinitScroll();
      initSwatch(_this.$vnd_main_ctn);
      vndHlp.wslst();
      vndHlp.cplst();
      quickViewInit();

      _this.showByGroup();
      _this.initGridSwitch();

      if (_this.$sort_ctn) {
        new vndTheme.Dropdowns(_this.$sort_ctn);
      }

      if (method == 'replace' ) {
        _this.scrollToMain(360);
      }
    })
    .catch(e => {
      console.error(e)
    });
  },

  getSections() {
    return [
      {
        section: this.$vnd_main_ctn.dataset.id,
      }
    ]
  },

  updateFilterTag(newTagParam, searchParams) {
    const currentParams = new URLSearchParams(window.location.search.substring(1));
    const tagsList = currentParams.get('constraint') ? currentParams.get('constraint').split(' ') : [];

    if (tagsList.indexOf(newTagParam) > -1) {
      tagsList.splice(tagsList.indexOf(newTagParam), 1);
    } else {
      tagsList.push(newTagParam);
    }

    if (tagsList.length > 0) {
      searchParams.set('constraint', tagsList.join(' '));
    } else {
      searchParams.delete('constraint');
    }

    collectionPage.filterProducts(searchParams.toString());
  },

  filterProducts(searchParams) {
    if ( vndTheme.stt.eb_ajx_flt ) {
      const sections = collectionPage.getSections();

      sections.forEach(function(section) {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const windowUrl = `${window.location.pathname}?${searchParams}`;
        collectionPage.replaceContent(url, windowUrl);
      });
    } else {
      location = `${window.location.pathname}?${searchParams}`;
    }
  }
}

// Filters
class CollectionFilters extends HTMLElement {
  constructor() {
    super();

    this.$container = document.querySelector('.collection-layout');
    this.$vnd_main_ctn = document.getElementById("collectionsContent");
    this.$filter_form = this.querySelector('form');
    this.$filter_price_min = this.querySelector('.vnd-price-min');
    this.$filter_price_max = this.querySelector('.vnd-price-max');
    this.$filter_price_range = this.querySelector('.vnd-price-range');

    this.$sort_ctn = document.querySelector('.collection-sort'),

    this.$filter_form.addEventListener('input', this.onSubmitHandler.bind(this));
    this.initPriceRange();
    this.initFilter();
  }

  initFilter() {
    if (!this.$sort_ctn) {
      return;
    }

    const $filter_lists = this.$container.querySelectorAll('.filter-list');

    $filter_lists.forEach(function($list) {
      if ($list.childElementCount < 1) {
        const $parentBlock = $list.closest('.sidebar-block');
        $parentBlock && $parentBlock.remove();
      }
    });
  }

  initPriceRange() {
    const _this = this;

    if (!this.$filter_price_range) {
      return;
    }

    const $parent = this.$filter_price_range.parentElement;
    const range_max = parseFloat(this.$filter_price_range.dataset.max) / 100;
    let width = $parent.offsetWidth - 18;
    let price_max = vndHlp.parseMoney(this.$filter_price_max.value, 'init') || range_max;
    let price_min = vndHlp.parseMoney(this.$filter_price_min.value, 'init') || 0;
    let m_f = vndCurrency.currency_format == 'money_with_currency_format'
      ? vndCurrency.money_format.replace(/\{\{(.*?)\}\}/g, '%s')
      : vndCurrency.money_with_currency.replace(/\{\{(.*?)\}\}/g, '%s');

    price_max = Math.ceil(price_max);
    price_min = Math.floor(price_min);

    if ( price_min == price_max ) {
      price_min--;
    }

    const range_str = price_min.toString() + ',' + price_max.toString();

    $(this.$filter_price_range).jRange({
      from: 0,
      to: Math.ceil(range_max),
      showScale: false,
      step: 1,
      format: m_f,
      isRange: true,
      width: width,
      ondragend: function(range) {_this.updatePriceFilter(range)},
      onbarclicked: function(range) {_this.updatePriceFilter(range)}
    }).jRange('setValue', range_str);
  }

  updatePriceFilter(range) {
    const r = range.split(',')
    const price_min = parseFloat(r[0]);
    const price_max = parseFloat(r[1]);
    const inputEvent = new Event('input', {
      bubbles: true,
      cancelable: true
    });

    this.$filter_price_max.value = price_max;
    this.$filter_price_min.value = price_min;

    this.$filter_form.dispatchEvent(inputEvent);
  }

  onSubmitHandler(event) {
    if (event.target.classList.contains('sidebar-search__input')) {
      return;
    }

    event.preventDefault();
    const formData = new FormData(this.$filter_form);
    const currentParams = new URLSearchParams(window.location.search.substring(1));
    const sortByParams = currentParams.get('sort_by');
    const searchParams = new URLSearchParams(formData);

    if (sortByParams) {
      searchParams.set('sort_by', sortByParams);
    }

    if (event.target.name == 'constraint') {
      collectionPage.updateFilterTag(event.target.value, searchParams)
    } else {
      collectionPage.filterProducts(searchParams.toString());
    }
  }
}
customElements.define('collection-filters', CollectionFilters);

// Remove filter
class FilterRemove extends HTMLElement {
  constructor() {
    super();

    this.$link = this.querySelector('.active-tag__item');
    this.$link.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    const currentParams = new URLSearchParams(window.location.search.substring(1));
    const tagToRemove = this.dataset.value;

    collectionPage.updateFilterTag(tagToRemove, currentParams);
  }
}
customElements.define('filter-remove', FilterRemove);

// Link filter - tags
class FilterLink extends HTMLElement {
  constructor() {
    super();

    this.$link = this.querySelector('.js-filter-link');
    this.$link.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    collectionPage.replaceContent(this.$link.href, this.$link.href);
  }
}
customElements.define('filter-link', FilterLink);

// Sorts
class CollectionSort extends HTMLElement {
  constructor() {
    super();

    this.$sort_by = document.getElementById('sort-by');
    this.$sort_by && this.initElements();
  }

  initElements() {
    const _this = this;
    const $sorts = this.querySelectorAll('.sort-wrapper .dd-pp__item');
    if ($sorts.length > 0) {
      const $sort_close = this.querySelector('.sort-wrapper .dd-pp__close');

      $sorts.forEach(function($node) {
        $node.addEventListener('click', function() {
          _this.$sort_by.firstChild.innerText = this.innerText;
          $sort_close.click();
          if (!this.classList.contains('active')) {
            _this.sort(this.dataset.value);
          }
        })
      });
    } else {
      _this.$sort_by.addEventListener('change', function() {
        _this.sort(this.value);
      });
    }
  }

  sort(sort_by) {
    const params = new URLSearchParams(window.location.search.substring(1));
    params.set('sort_by', sort_by);
    collectionPage.filterProducts(params.toString());
  }
}
customElements.define('collection-sort', CollectionSort);


document.addEventListener('DOMContentLoaded', function() {
  if (vndTpl != 'search') {
    collectionPage.init();
  }
});
